<template>
  <div style="overflow-x: hidden;background: #F9FAFB;">
    <div style="position: relative; transition: all .5s; margin-top: 0;">
    <img src="../../../assets/img/homeTopBg.png" style="width: 100%;">
    <div class="mesearch" style="position: absolute;top: 0; left: 0; width: 100%">
      <div v-if="!form.search && rollShow" style="position: absolute;font-size: 12px;color: #ffffff;top: 18px;left: 50px;z-index: 11;overflow: hidden;width: 65vw;height: 18px;pointer-events: none;">
        <van-swipe
          vertical
          @change="rollChange"
          :touchable="false"
          :autoplay="goodsCheckHotConfig.rollList[currentRowIndex] ? goodsCheckHotConfig.rollList[currentRowIndex].stopTime * 1000 : 3000"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item, index) in goodsCheckHotConfig.rollList" :key="index">
            <span style="font-family: lthj;">{{item.wordName}}</span>
          </van-swipe-item>
        </van-swipe>
      </div>
      <van-search
        v-model="form.search"
        shape="round"
        background="transparent"
        style="position: relative; z-index: 10"
        placeholder=""
        @click="modifyData.isShowNum++"
      >
          <div slot="left-icon">
              <img :src="icon.search" style="width: 13px;margin-left: 12px;transform: translateY(1px)">
          </div>
<!--        <div style="line-height: 20px;font-size: 18px;color: white; width: 30px" class="centerBox"  slot="action">-->
<!--          <div style="font-size: 12px;" @click="onSearch">搜索</div>-->
<!--        </div>-->
      </van-search>
        <swiper
                ref="mySwiper"
                v-if="swiperShow"
                @tap="bannerClick(bannerList[swiper.realIndex])"
                :options="swiperOption">
                <!-- height: 38.93vw;width: 87.47vw; -->
            <swiper-slide v-for="item in bannerList" :key="item.id" style="height: 38.93vw;width: 87.47vw;border-radius: 2.67vw;overflow: hidden">
<!--                <div style="height: 100%;width: 100%; background: #8ECDFF"></div>-->
                          <img :src="item.photoPath"
                               style="transform: translateZ(0);height: 100%;width: 100%;">
            </swiper-slide>
        </swiper>
    </div>
    </div>
    <div style="width: 100%;margin-top: -19.3vw;position: relative;z-index: 1;background: #F9FAFB;border-radius: 6.13vw 6.13vw 0 0">
    <div style="padding: 0 3.2%;">
        <div class="centerBox" style="justify-content: left;padding-top: 4.53vw;font-weight: bold">
            <img src="../../../assets/img/homeLogo.png" style="width: 4.8vw; height: 4.53vw;margin-right: 2.4vw">
            <div style="font-size: 3.47vw; color: #393939">
                欢迎使用鼎汇丰
            </div>
        </div>
      <div class="shopCard homeCategoryGrid" style=" border-radius: 11px;margin-top: 4.27vw">
        <van-grid :column-num="4" :border="false" icon-size="49" clickable>
          <van-grid-item
            v-for="(value, index) in categorys"
            :key="value.id"
            style="font-size: 11px;"
            @click="toCategorySearch(index)"
            :icon="value.imgPath"
            :text="value.categoryName"></van-grid-item>
        </van-grid>
      </div>
      <div>
    </div>
    </div>
        <div style="margin-bottom: 5.07vw;margin-top: 6vw">
            <van-tabs :border="false" v-model="form.category" @change="categoryChange" class="categoryTab" line-width="2.93vw" line-height=".8vw" :ellipsis="false" title-active-color="#393939">
<!--                <van-tab :name="0">-->
<!--                    <div slot="title" style="position: relative">-->
<!--                        推荐-->
<!--                    </div>-->
<!--                </van-tab>-->
                <van-tab v-for="(item, index) in categorys" :name="index" :key="item.id">
                    <div slot="title" style="position: relative">
                        {{item.categoryName}}
                    </div>
                </van-tab>
            </van-tabs>
        </div>
      <div style="width: 94%; margin: 0 auto 15.73vw auto;position: relative">
          <div style="display: flex;width: 100%;justify-content: space-between">
              <div style="width: 45.7vw;">
<!--                  @plusTwo="changeCartGoodsNumTwo(arguments)" @minusTwo="minusCartGoodsNumTwo(arguments)"-->
                  <div v-for="(item, index) in shopList" :key="item.id">
                      <my-shop-card style="width: 45.7vw;" v-if="index % 2 == 0" :row="item" @toInfo="toInfo" @expend="changeExpend" @changeShop="changeShop"></my-shop-card>
                  </div>
              </div>
              <div style="width: 45.7vw;">
                  <div v-for="(item, index) in shopList" :key="item.id">
                      <my-shop-card style="width: 45.7vw;" v-if="index % 2 != 0" :row="item" @toInfo="toInfo" @expend="changeExpend" @changeShop="changeShop"></my-shop-card>
                  </div>
              </div>
          </div>
          <div v-if="!shopList.length" style="font-size: 3.2vw;color: #999999;width: 100%; text-align: center">暂时没有更多啦~</div>

          <!--        <van-list-->
<!--          v-model="pagingData.loading"-->
<!--          :finished="pagingData.finished"-->
<!--          @load="onLoad"-->
<!--          finished-text="暂时没有更多啦~"-->
<!--        >-->
<!--          -->
<!--        </van-list>-->
      </div>
    </div>
      <van-popup v-model="shopShow" closeable position="bottom" round :style="{ height: '40%' }" >
          <div style="margin-top: 40px;padding: 0 5.3vw">
              <div style="display: flex;padding-bottom: 6.8vw;border-bottom: .27vw solid rgba(151, 151, 151, .17)">
                  <img :src="shopInfo.goodsImg" style="width: 19.1vw;height: 19.1vw">
                  <div class="shopListInfo" style="margin-left: 2.4vw">
                      <div style="font-size: 3.73vw; width: 55vw; margin-top: .8vw;font-weight: bold">
                          {{shopInfo.goodsName}}
                          <!--          精品红油-->
                      </div>
                      <div style="justify-content: left;margin: 1.87vw 0 1.87vw;color: #9f9f9f;font-size: 2.67vw">
                          销量: {{shopInfo.monthlySales || 0}}
                      </div>
                      <div  class="shopCardMoney" style="margin-bottom: 0;line-height: 5.33vw;height: 5.33vw">
                          <div>
                              <span style="font-size: 3.47vw;letter-spacing: -.3vw;">￥</span><span style="font-size: 5.33vw;font-weight: bold">{{$utils.priceFormat(shopInfo.price)}}</span>
                          </div>
                      </div>
                  </div>
              </div>
              <div style="margin-top: 7.5vw;justify-content: space-between" class="centerBox">
                  <div style="font-size: 3.4vw">数量</div>
                  <div style="" class="shopListStepper">
                      <van-stepper
                              v-model="shopQty"
                              :step="shopInfo.miniBuyQty"
                              input-width="19.1vw"
                              button-size="4.8vw"
                              integer
                              :min="shopInfo.miniBuyQty"
                              >
                      </van-stepper>
                  </div>
              </div>
              <div style="margin-top: 6.3vw" @click="addCart">
                  <div style="width: 100%;border: .2vw solid #da4e4e;color: #da3939; font-size: 3.9vw;height: 9.2vw;border-radius: 999px" class="centerBox">
                      加入购物车
                  </div>
              </div>
          </div>
      </van-popup>
      <shop-inquire @back="modifyData.isShowNum++" :is-show-num="modifyDataInquire.isShowNum" :row="modifyDataInquire.row"></shop-inquire>
      <search @onSearch="onSearch" :is-show-num="modifyData.isShowNum"></search>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import { mapActions } from 'vuex'
import homeTopBg from '../../../assets/img/homeTopBg.png'
import search from '../../../assets/img/icon/search.png'
import hgdl from '../../../assets/img/category/hgdl.png'
import rlsp from '../../../assets/img/category/rlsp.png'
import glxl from '../../../assets/img/category/glxl.png'
import jkyp from '../../../assets/img/category/jkyp.png'
import jsyl from '../../../assets/img/category/jsyl.png'
import fsmt from '../../../assets/img/category/fsmt.png'
import scsp from '../../../assets/img/category/scsp.png'
import qb from '../../../assets/img/category/qb.png'
// import hotIcon from '../../../assets/img/hotIcon.png'
// import avatar from '../../../assets/img/menu_03.png'
// import successIcon from '../../../assets/img/successIcon.png'
// import navbarIconLeft from '../../../assets/img/navbar_icon_search.png'
// import myInfoIcon from '../../../assets/img/navbar_icon_notice.png'
// import cartIcon from '../../../assets/img/cartIcon.png'

export default {
  components: {
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  },
  data () {
    return {
      shopShow: false,
      swiperOption: {
      },
      modifyData: {
        isShowNum: 0
      },
      modifyDataInquire: {
        isShowNum: 0,
        row: {}
      },
      swiperShow: false,
      customStepperConfig: {},
      currentQty: 0,
      bannerList: [],
      adverShopActive: {},
      shopQty: 1,
      buttonList: [],
      fullscreenShow: false,
      showShopActive: false,
      showShopMessage: false,
      sku: {
        // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
        // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
        tree: [
        ],
        // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
        list: [],
        // price: '1.00', // 默认价格（单位元）
        // stock_num: 227, // 商品总库存
        hide_stock: false, // 是否隐藏剩余库存
        startSaleNum: 0, // 起售数量
        quota: 0, // 当前限购数量
        limitQty: 0 // 总限购数量
      },
      goods: {
        // 默认商品 sku 缩略图
        picture: ''
      },
      noMessageShow: true,
      initialSku: {},
      shopInfo: {
        minPrice: 0,
        maxPrice: 0,
        goodsImg: [],
        goodsName: '',
        tag: '',
        salesVolume: 0
      },
      form: {
        search: '',
        category: ''
      },
      banner1: [],
      banner9: [],
      skipList: [],
      normalShopActiveList: [],
      seckillInfo: {
        id: ''
      },
      categorys: [],
      shopList: [],
      avatar: window.localStorage.avatar,
      pagingData: {
        loading: false,
        finished: false,
        currentPage: 1,
        pageSize: 10
      },
      bottomShopActive: {},
      msgNum: 0,
      currentColor: '#10C3C4',
      currentOpa: 1,
      MallHeadlines: [],
      icon: {
        search,
        homeTopBg
        // talkTalk,
        // frontIcon,
        // hotIcon,
        // avatar,
        // myInfoIcon,
        // cartIcon,
        // navbarIconLeft
      },
      userData: {},
      defaultSearch: '',
      goodsCheckHotConfig: {
        historyList: [],
        hotList: [],
        rollList: []
      },
      isLogin: null,
      banner11: [],
      rollShow: true,
      currentRowIndex: 0,
      levelUpShow: false,
      plusShow: false,
      selectItem: {},
      selectName: 0,
      plusEndTime: ''
      // currentOpa: '1',
      // opaSetInterval: ''
    }
  },
  watch: {
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.$swiper
    }
  },
  created () {
    this.selectCategory2()
    // this.getSurpriceSeckillList()
    this.selectGoodsCheckHotConfig()
    // this.seckillIndex()
    const self = this
    this.customStepperConfig = {
      handleStepperChange (currentValue) {
        self.currentQty = currentValue
      }
    }
    this.Slideshow()
    // this.showMember3()
  },
  mounted () {
    this.noMessageShow = !window.localStorage.noMessage
  },
  destroyed () {
    // clearInterval(this.opaSetInterval)
  },
  activated () {
  },
  methods: {
    ...mapActions([
      'set_row',
      'set_keepAliveList'
    ]),
    // startOpaSetInterval () {
    //   this.opaSetInterval = setInterval(() => {
    //     let opc = this.$refs.topBanner.$el.children[0].style.transform.replace('translateX(', '').replace('px)', '') / document.body.clientWidth
    //     this.currentOpa = opc.toString().split('.')[1] ? (1 - opc.toString().replace('-', '')) < 0.5 ? opc.toString().replace('-', '') : 1 - opc.toString().replace('-', '') : 1
    //   }, 1)
    // },
    toLevelUp () {
      this.$router.push({
        path: '/myMenu/mine',
        query: {
          levelUp: 1
        }
      })
    },
    cancleLevelUp () {
      this.$request.shop.editUpGradeKnow()
      this.queryRechargePlus()
      this.levelUpShow = false
    },
    // categoryChange (name) {
    //   this.shopList = this.categorys[name].list
    // },
    categoryChange (name) {
      this.selectName = name
      this.categoryChange2(this.categorys[name])
    },
    showMember3 () {
      const self = this
      const loading = self.$toast.loading({
        duration: 0
      })
      self.$request.shop.query()
        .then((response) => {
          loading.clear()
          if (response.code === '200') {
            if (response.data.growthValue >= 3980 && !response.data.knowFlag) {
              this.levelUpShow = true
            } else {
              this.queryRechargePlus()
            }
          } else {
            self.$toast(response.msg)
          }
        })
    },
    queryRechargePlus () {
      const self = this
      const loading = self.$toast.loading({
        duration: 0
      })
      self.$request.shop.queryRechargePlus()
        .then((response) => {
          loading.clear()
          if (response.code === '200') {
            if (!response.data.knowFlag) {
              this.plusShow = true
              this.plusEndTime = response.data.plusEndTime || ''
            } else {
              this.showMessage()
            }
          } else {
            self.$toast(response.msg)
          }
        })
    },
    topSwipeChange () {
      this.currentColor = this.banner1[this.swiper.realIndex].backgroundColor || '#10C3C4'
    },
    noMessage () {
      localStorage.setItem('noMessage', '1')
      this.showShopMessage = false
      if (!sessionStorage.getItem('showShopActive')) {
        sessionStorage.setItem('showShopActive', '1')
        if (this.adverShopActive.id) {
          this.showShopActive = true
          setTimeout(() => {
            this.showShopActive = false
          }, 10000)
        }
      }
      setTimeout(() => {
        this.noMessageShow = false
      }, 300)
    },
    skuSelected (skuValue) {
      if (skuValue.selectedSkuComb) {
        this.sku.startSaleNum = skuValue.selectedSkuComb.buyNumMin || 0
        this.sku.quota = this.sku.limitQty > skuValue.selectedSkuComb.buyNumMax || this.sku.limitQty === 0 ? skuValue.selectedSkuComb.buyNumMax : this.sku.limitQty
      } else {
        this.sku.quota = this.sku.limitQty
      }
    },
    addCart () {
      console.log(this.shopInfo)
      const self = this
      self.$toast.loading({
        duration: 0
      })
      if (this.selectItem.buyQty) {
        this.changeCartGoodsNum()
        return
      }
      if (this.selectItem.minGoodsList) {
        this.selectItem.minGoodsList.forEach(item => {
          this.$set(item, 'goodsId', item.minId)
          this.$set(item, 'imgPath', item.goodsImg)
          this.$set(item, 'qty', 0)
        })
      }
      self.$request.shop.addCartGoods({
        qty: this.shopQty,
        minCartGoodsList: this.selectItem.minGoodsList || [],
        ...this.shopInfo
      })
        .then((response) => {
          self.$toast.clear()
          if (response.code === '200') {
            self.$toast({
              message: '已成功加入购物车'
            })
            self.shopShow = false
            self.categoryChange2(this.categorys[self.selectName])
          } else {
            // console.log(response)
            self.$toast(response.msg)
          }
        })
    },
    // 第二次加购物车
    changeCartGoodsNum () {
      this.$toast.loading({
        duration: 0
      })
      let opFlag = 0
      let chaNumber = 0
      console.log(this.shopQty)
      console.log(this.selectItem.buyQty)
      if (this.shopQty > this.selectItem.buyQty) {
        opFlag = 1
        chaNumber = Number(this.shopQty) - Number(this.selectItem.buyQty)
      } else {
        opFlag = 2
        chaNumber = Number(this.selectItem.buyQty) - Number(this.shopQty)
      }
      this.$request.shop.changeCartGoodsNum({
        goodsId: this.shopInfo.id,
        category: this.shopInfo.category,
        miniBuyQty: chaNumber,
        minCartGoodsList: this.shopInfo.minCartGoodsList,
        opFlag: opFlag
      })
        .then((response) => {
          this.$toast.clear()
          if (response.code === '200') {
            this.categoryChange2(this.categorys[this.selectName])
            this.shopShow = false
          } else {
            this.shopShow = false
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 第一次增加附属品
    addCartTwo (row, children) {
      // console.log(row)
      const self = this
      const minCartGoodsList = []
      if (row) {
        minCartGoodsList.push({
          category: row.category,
          goodsId: row.minId,
          goodsName: row.goodsName,
          qty: row.miniBuyQty,
          imgPath: row.goodsImg,
          price: row.price,
          unitPrice: row.unitPrice
        })
      }
      self.$toast.loading({
        duration: 0
      })
      self.$request.shop.addCartGoods({
        qty: children.specificationQty,
        ...children,
        goodsId: children.id,
        mainGoodsAddFlag: 1,
        miniBuyQty: children.miniBuyQty,
        minCartGoodsList: minCartGoodsList
      })
        .then((response) => {
          self.$toast.clear()
          if (response.code === '200') {
            // children.buyQty++
            // this.selectCategory2()
            this.categoryChange2(this.categorys[this.selectName])
          } else {
            // console.log(response)
            self.$toast(response.msg)
          }
        })
    },
    // 第二次增加附属品
    changeCartGoodsNumTwo (data) {
      console.log(data[1])
      if (data[1].buyQty > 0) {
        if (!data[0].buyQty) {
          this.addCartTwo(data[0], data[1])
          return
        }
        this.$toast.loading({
          duration: 0
        })
        const minCartGoodsList = []
        if (data[0]) {
          minCartGoodsList.push({
            category: data[0].category,
            goodsId: data[0].minId,
            opFlag: 1
          })
        }
        this.$request.shop.changeCartGoodsNum({
          goodsId: data[1].id,
          category: data[1].category,
          opFlag: 0,
          miniBuyQty: data[1].miniBuyQty,
          minCartGoodsList: minCartGoodsList
        })
          .then((response) => {
            this.$toast.clear()
            if (response.code === '200') {
              // this.searchSubmit()
              this.categoryChange2(this.categorys[this.selectName])
            } else {
              this.$toast(response.msg)
            }
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.$toast('请选择主商品')
      }
    },
    // 第二次减少附属品
    minusCartGoodsNumTwo (data) {
      console.log(data[1])
      if (!data[0].buyQty) {
        this.addCart(data[0])
        return
      }
      this.$toast.loading({
        duration: 0
      })
      const minCartGoodsList = []
      if (data[0]) {
        minCartGoodsList.push({
          category: data[0].category,
          goodsId: data[0].minId,
          opFlag: 2
        })
      }
      this.$request.shop.changeCartGoodsNum({
        ...data[1],
        goodsId: data[1].id,
        opFlag: 0,
        miniBuyQty: data[1].miniBuyQty,
        minCartGoodsList: minCartGoodsList
      })
        .then((response) => {
          this.$toast.clear()
          if (response.code === '200') {
            this.categoryChange2(this.categorys[this.selectName])
          } else {
            this.$toast(response.msg)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    userInfo (type) {
      const self = this
      const loading = self.$toast.loading({
        duration: 0
      })
      self.$request.mineMessage.userInfo()
        .then((response) => {
          loading.clear()
          if (!type) {
            if (response.data.memberLevel === 1) {
              this.$router.push('/PlusMembership')
            } else {
              this.$toast('Plus会员仅供普通用户购买')
            }
          } else {
            this.userData = response.data
          }
        })
    },
    changeShop (item) {
      console.log(item)
      this.selectItem = item
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.shopGetById(item.id)
        .then((response) => {
          this.$toast.clear()
          if (item.buyQty) {
            this.shopQty = item.buyQty
          } else {
            this.shopQty = item.miniBuyQty
          }
          this.shopInfo = response.data
          this.shopShow = true
        })
        .catch((error) => {
          console.log(error)
        })
    },
    toNotice () {
      this.$router.push({ name: 'Notice' })
    },
    toInfo (id) {
      this.$router.push({
        name: 'ShopInfo',
        query: {
          id
        }
      })
    },
    toCategorySearch (index) {
      this.set_keepAliveList([])
      this.$router.push({
        name: 'ShopSearch',
        query: {
          index
        }
      })
    },
    bannerClick (item, isSeckill) {
    },
    selectBanner (value) {
      this.$request.shop.selectBanner(value)
        .then((response) => {
          if (value === 1) {
            this.currentColor = response[0].backgroundColor || '#10C3C4'
            this.swiperOption = {
              loop: response.length != 1, // 无限循环
              slidesPerView: 1.1,
              loopedSlides: 5,
              loopAdditionalSlides: 5,
              spaceBetween: 25,
              watchSlidesProgress: true,
              centeredSlides: true,
              observer: true, // 修改swiper自己或子元素时，自动初始化swiper
              observeParents: true, // 修改swiper的父元素时，自动初始化swiper
              autoplay: {
                pauseOnMouseEnter: true,
                delay: 5000,
                disableOnInteraction: false
              },
              effect: 'coverflow',
              coverflowEffect: {
                rotate: 0,
                depth: 120,
                slideShadows: false
              }
            }
            this.swiperShow = true
          }
          this['banner' + value] = response || []
        })
        .catch((error) => {
          console.log(error)
        })
    },
    showMessage () {
      if (!localStorage.getItem('showShopMessageStorage')) {
        this.showShopMessage = true
        localStorage.setItem('showShopMessageStorage', 1)
      } else {
        if (!sessionStorage.getItem('showShopActive')) {
          sessionStorage.setItem('showShopActive', '1')
          if (this.adverShopActive.id) {
            this.showShopActive = true
            setTimeout(() => {
              this.showShopActive = false
            }, 10000)
          }
        }
      }
    },
    getActiveGoodsList () {
      this.$request.shop.getActiveGoodsList()
        .then((response) => {
          this.normalShopActiveList = response.normalShopActiveList
          this.skipList = response.plusShopActiveList
          this.adverShopActive = response.adverShopActive
          this.bottomShopActive = response.bottomShopActive
          this.buttonList = response.buttonList || []
          // if (this.adverShopActive.id && !sessionStorage.getItem('showShopActive')) {
          //   this.showShopActive = true
          //   sessionStorage.setItem('showShopActive', '0')
          // }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    messageCancel () {
      this.showShopMessage = false
      if (!sessionStorage.getItem('showShopActive')) {
        sessionStorage.setItem('showShopActive', '1')
        if (this.adverShopActive.id) {
          this.showShopActive = true
          setTimeout(() => {
            this.showShopActive = false
          }, 10000)
        }
      }
    },
    noReadMessageCnt () {
      this.$request.notice.noReadMessageCnt(0)
        .then((response) => {
          this.msgNum = response.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    selectGoodsCheckHotConfig () {
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.selectGoodsCheckHotConfig()
        .then((response) => {
          this.goodsCheckHotConfig = {
            historyList: response.data.historyList || [],
            hotList: response.data.hotList || [],
            rollList: response.data.rollList || []
          }
          if (this.goodsCheckHotConfig.rollList.length) {
            this.defaultSearch = this.goodsCheckHotConfig.rollList[0].wordName || ''
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    rollChange (index) {
      this.currentRowIndex = index
      this.defaultSearch = this.goodsCheckHotConfig.rollList[index].wordName || ''
    },
    selectCategory2 () {
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.pageCategory2()
        .then((response) => {
          this.$toast.clear()
          this.categorys = response.data
          if (this.shopList = []) {
            this.categoryChange2(this.categorys[0])
          }
          // this.shopList = response.data[0].list
        })
        .catch((error) => {
          console.log(error)
        })
    },
    changeExpend (item) {
      item.show = !item.show
    },
    categoryChange2 (item) {
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.listCategoryById({ id: item.id })
        .then((response) => {
          this.$toast.clear()
          response.data[0].list.forEach(item => {
            this.$set(item, 'show', false)
            if (this.shopList.length) {
              this.shopList.forEach(cate => {
                if (item.id === cate.id && cate.show) {
                  item.show = true
                }
              })
            }
          })
          this.shopList = response.data[0].list
        })
    },
    Slideshow () {
      this.$request.shop.Slideshow()
        .then((response) => {
          this.bannerList = response.data
          this.swiperOption = {
            loop: true, // 无限循环
            slidesPerView: 1.1,
            loopedSlides: 5,
            loopAdditionalSlides: 5,
            spaceBetween: 25,
            watchSlidesProgress: true,
            centeredSlides: true,
            observer: true, // 修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, // 修改swiper的父元素时，自动初始化swiper
            autoplay: {
              pauseOnMouseEnter: true,
              delay: 5000,
              disableOnInteraction: false
            },
            effect: 'coverflow',
            coverflowEffect: {
              rotate: 0,
              depth: 120,
              slideShadows: false
            }
          }
          this.swiperShow = true
        })
        .catch((error) => {
          console.log(error)
        })
    },
    onSearch (value) {
      console.log(1)
      this.modifyDataInquire.isShowNum++
      this.modifyDataInquire.row = {
        title: value,
        type: 'text'
      }
    },
    searchSubmit () {
      // this.$router.replace({path: '/myMenu/shopInquire', query: {name: this.form.name}})
      // this.initPage()
      this.onLoad()
    },
    onLoad () {
      this.selectGoods()
      this.pagingData.currentPage++
    },
    initPage () {
      // this.shopList = []
      this.pagingData = {
        loading: false,
        finished: false,
        currentPage: 1,
        pageSize: 10
      }
    },
    selectGoods () {
      this.$request.shop.goods({ goodsName: this.row.title }, {
        currentPage: this.pagingData.currentPage,
        pageSize: this.pagingData.pageSize
      })
        .then((response) => {
          if (response.code !== '200') {
            this.pagingData.loading = false
            this.pagingData.finished = true
            return
          }
          this.pagingData.loading = false
          if (response.data.records.length < this.pagingData.pageSize) {
            this.pagingData.finished = true
          }
          response.data.records.forEach(item => {
            this.$set(item, 'show', false)
            console.log(item)
            console.log(this.shopList)
            if (this.shopList.length) {
              this.shopList.forEach(cate => {
                if (item.id === cate.id && cate.show) {
                  item.show = true
                }
              })
            }
            this.shopList = []
          })
          // this.shopList = response.data.records
          this.shopList.push(...response.data.records)
          console.log(this.shopList)
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style>

  .activityTitle {
    color: black;
    font-size: 3.73vw;
    position: relative;
    font-family: FZLTZHJW;
  }
  .activitySubheading {
    margin-top: 1.2vw;
    font-size: 3.2vw;
    position: relative;
    background: linear-gradient(60deg, #FE903A 0%, #F5AAC8 0%, #C98FEE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .seckillLeft {
    margin-right: 1.46vw;
    font-size: 3.2vw;
    color: #37C2BB;
    position: relative;
  }
  .seckillRight {
    font-size: 2.4vw;
    border-radius: .53vw;
    background: #37C2BB;
    color: white;
    position: relative;
    padding: 0 .21vw;
    font-family: DIN_Medium;
    display: flex;
    align-items: flex-end;
    height: 3.2vw;
  }
  .seckillRight div {
  }
  .seckillRightMH {
    font-weight: bold;
    color: #37C2BB;
    position: relative;
    font-size: 2.4vw;
    margin: 0 .47vw;
    display: inline-block;
    font-family: DIN_Medium;
  }
  .activityImg {
    border-radius: 1.33vw;
    overflow: hidden;
  }
  .activityPrice {
    font-size: 2.4vw;
    font-family: DIN_Medium;
    color: #FF4400;
    margin-top: -1vw;
    height: 2.4vw;
    text-align: center;
  }
  .activityRPrice {
    font-size: 2.13vw;
    font-family: DIN_Medium;
    color: #A69C92;
    margin-top: .4vw;
    height: 2.13vw;
    text-decoration: line-through;
    text-align: center;
  }
</style>
